import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb2008',
    ecrans: ['00-2'],
    params: ['?type', 
             '?prucleint', 
             '?prbcleint', 
             '?prvcleint', 
             '?vaesysnatctb', 
             '?tymcleint', 
             '?doccleintref', 
             '?pecann',
             '?elecleint', 
             '?niveau', 
             '?annper_deb', 
             '?annper_fin']    
});
